namespace TabAurous.Inventory {
    export interface MRPForm {
        TransId: Serenity.StringEditor;
        ProductId: Serenity.IntegerEditor;
        UOM: Serenity.IntegerEditor;
        AttributeId: Serenity.IntegerEditor;
        Minimum0: Serenity.DecimalEditor;
        Maximum0: Serenity.DecimalEditor;
        Minimum1: Serenity.DecimalEditor;
        Maximum1: Serenity.DecimalEditor;
        Minimum2: Serenity.IntegerEditor;
        Maximum2: Serenity.IntegerEditor;
    }

    export class MRPForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MRP';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MRPForm.init)  {
                MRPForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(MRPForm, [
                    'TransId', w0,
                    'ProductId', w1,
                    'UOM', w1,
                    'AttributeId', w1,
                    'Minimum0', w2,
                    'Maximum0', w2,
                    'Minimum1', w2,
                    'Maximum1', w2,
                    'Minimum2', w1,
                    'Maximum2', w1
                ]);
            }
        }
    }
}
